import React, { Component } from 'react';
import { ReactComponent as CargoInfo } from 'Icons/cargoinfo.svg';
import Select from 'react-select';
import { SingleDatePicker } from 'react-dates';
import TimePicker from 'rc-time-picker';
import Moment from 'moment';

class VehicleDetails extends Component {
    constructor(props) {
        super(props);
        this.trip = props.trip;
        this.state = {
            activeView: 1,
            trip: this.trip,
            vehicleCopy: []
        }
        this.viewMode = props.viewMode;
    }

    setVehicleType = (vehicleType)=> {
        if(this.viewMode) {
            return;
        }
        const { trip } = this.state;
        trip.vehicleType = vehicleType.value;
        trip.vehicleTypeName = vehicleType.name;
        trip.carryingCapacity = vehicleType.carrying_capacity;
        trip.requiredVehicleCapacity = vehicleType.vehicle_capacity_MT;
        trip.vehicleCapacity = vehicleType.vehicle_capacity;
        this.trip.setVehicleType(vehicleType.value, vehicleType.name);
        this.trip.setRequiredVehicleCapacity(vehicleType.vehicle_capacity_MT);
        this.trip.setVehicleCapacity(vehicleType.vehicle_capacity);
        this.trip.setSAPVehicleId(vehicleType.sap_mapping_id);
        this.setState({ trip });
        this.props.onChange()
    }

    setVehicleBodyType = (vehicleBodyType)=> {
        if(this.viewMode) {
            return;
        }
        const { trip } = this.state;
        trip.vehicleBodyType = vehicleBodyType.value;
        trip.vehicleBodyTypeName = vehicleBodyType.name;
        this.trip.setVehicleBodyType(vehicleBodyType.value, vehicleBodyType.name);
        this.setState({ trip });

        this.props.onChange()
    }

    onChangeRemarks = (e)=> {
        const { trip } = this.state;
        trip.remarks = e.target.value;
        this.trip.setRemarks(e.target.value);
        this.setState({ trip });
        this.props.onChange()
    }

    render() {
        const { 
            vehicleTypes,
            vehicleBodyTypes,
            trip,
            isError
        } = this.props;

        return (
            <div className='vehicleDetails pb-20'>
                <div className='header pv-10 ph-20 border-bottom-light-2'>Add New Trip</div>
                <div className='ph-20'>
                    <div className='mt-20 flex mb-20'>
                            <CargoInfo />
                            <div className='ml-10 header'>Vehicle Details</div>
                    </div>
                    <div className='flex'>
                        <div className='col-2 mr-15'>
                            <div className='rfqlabel'>Select Vehicle Type <sup className='error-color fs-14'>*</sup></div>
                            <Select 
                                onChange={this.setVehicleType}
                                options={vehicleTypes} 
                                value={vehicleTypes.find((vehicleType)=> {
                                    return vehicleType.value === this.trip.vehicleType
                                })} 
                                getOptionLabel={option => option.name}
                            />
                            {isError && !(this.trip.vehicleType) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Select The Field</span>}
                        </div>
                        <div className='col-2 ml-15'>
                            <div className='rfqlabel'>Select Vehicle Body Type <sup className='error-color fs-14'>*</sup></div>
                            <Select 
                                options={vehicleBodyTypes}
                                value={vehicleBodyTypes.find((vehicleBodyType)=> {
                                    return vehicleBodyType.value === this.trip.vehicleBodyType
                                })}
                                onChange={this.setVehicleBodyType}
                                getOptionLabel={option => option.name}
                            />
                            {isError && !(this.trip.vehicleBodyType) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Select The Field</span>}
                        </div>
                    </div>
                    <div className='mt-20'>
                        <div className='col-2 mr-15 tStart'>
                            <div className='rfqlabel'>Select Placement Time</div>
                            <div className='flex'>
                                <SingleDatePicker
                                    noBorder={true}
                                    displayFormat={"DD MMM YYYY"}
                                    isOutsideRange={() => false}
                                    hideKeyboardShortcutsPanel={true}
                                    placeholder={"Placement Date"}
                                    numberOfMonths={2}
                                    date={this.trip.placementTime ? Moment(this.trip.placementTime) : ''} 
                                    onDateChange={(placementDate) =>{
                                        if(this.viewMode) {
                                            return;
                                        }
                                        const date = placementDate.format('YYYY-MM-DD') + ' ' + Moment(this.trip.placementTime).format('HH:mm')
                                        this.trip.setPlacementTime(new Date(date).getTime());
                                        this.setState({ trip: this.trip });
                                        this.props.onChange()
                                    }}
                                    focused={this.state.focusedStart} 
                                    onFocusChange={({ focused }) => this.setState({ focusedStart: focused })} 
                                />
                                <TimePicker
                                    placeholder={"Placement Time"}
                                    showSecond={false}
                                    value={this.trip.placementTime ? Moment(this.trip.placementTime) : ''}
                                    className="ht-40 wt-150 border-status-bar br-5"
                                    onChange={(placementTime) =>{
                                        if(this.viewMode) {
                                            return;
                                        }
                                        const date = Moment(this.trip.placementTime).format('YYYY-MM-DD') + ' ' + placementTime.format('HH:mm')
                                        this.trip.setPlacementTime(new Date(date).getTime());
                                        this.setState({ trip: this.trip });
                                        this.props.onChange()
                                    }}
                                    format={'h:mm a'}
                                    use12Hours
                                    inputReadOnly
                                />
                            </div>
                        </div>
                        <div className='col-2 ml-15'>
                            
                        </div>
                    </div>
                    <div className='mt-20'>
                        <div className='rfqlabel'>Remarks</div>
                        <textarea 
                            className='ht-40 wt-800 border-light br-5'
                            value={this.trip.remarks}
                            onChange={this.onChangeRemarks}
                            name="remarks"
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default VehicleDetails;